import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { Layout } from '../components'
import { ExpensesRoutes, IncomesRoutes } from '../routes'

export default () => (
	<Layout>
		<Switch>
			<Route path='/gastos' exact={false}>
				<ExpensesRoutes />
			</Route>
			<Route path='/ingresos' exact={false}>
				<IncomesRoutes />
			</Route>
			<Redirect to='/gastos' />
		</Switch>
	</Layout>
)
